import * as actionTypes from '../actionsTypes/Types';

// DASHBOARD_COUNT ACTION
export const dashboardCountAction = (type,payload) => {
    return sendToReducer(type,payload)
}


function sendToReducer(type,payload) {
    return {
        type: type,
        payload: payload,
    };
}
